import { useEffect } from "react";
import "./InativarDesvioEditarModal.css";

export default function InativarDesvioEditarModal({ open, label, onClose, onConfirm }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "Enter") onConfirm?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose, onConfirm]);

  if (!open) return null;

  return (
    <div className="dveim-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className="dveim-modal" role="dialog" aria-modal="true" aria-label="Inativar item">
        <header className="dveim-header">
          <h3 className="dveim-title">Inativar</h3>
          <button type="button" className="dveim-close" aria-label="Fechar" onClick={onClose}>
            ×
          </button>
        </header>

        <div className="dveim-body">
          Deseja <strong>inativar</strong> "{label || "este item"}"?
        </div>

        <footer className="dveim-footer">
          <button type="button" className="dveim-btn dveim-btn--ghost" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="dveim-btn dveim-btn--warn" onClick={onConfirm}>
            Inativar
          </button>
        </footer>
      </div>
    </div>
  );
}
